import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import './sidebar.css'

const SubMenu = ({item}) => {
    const [subnav, setSubnav] = useState(false);
    const [activeNav, setActiveNav] = useState(0)
  
    const showSubnav = () => setSubnav(!subnav);

    const navigate = useNavigate();
    const params = useParams();

    const changeActiveTab = (i, text) => {
      setActiveNav();
      navigate(item.title)
  }

    return(
        <>
            <SidebarLink to={item.path} onClick={item.subNav && showSubnav} >
                <div>
                <img src={item.TabIcon} alt="" />
                
                <SidebarLabel className={({ isActive }) => (isActive ? "link-active" : "link")} >{item.title}</SidebarLabel>
                </div>
                <div>
                {item.subNav && subnav
                    ?  <img src={item.iconOpened} alt="dropdown" /> 
                    : item.subNav
                    ?  <img src={item.iconClosed} alt="dropdown" /> 
                    : null}
                </div>
            </SidebarLink>
          {subnav &&
            item.subNav.map((item, index) => {
              return (
                <DropdownLink to={item.path} key={index}>
                  <img src={item.Tabicon} alt="" /> 
                  <SidebarDropdown>{item.title}</SidebarDropdown>
                </DropdownLink>
              );
            })}
        </>
    )


}

  
const SidebarLink = styled(Link)`
  display: flex;
  color: #e1e9fc;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  /* padding: 20px; */
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 1.8rem;
  width: 100% !important;
  
  &:hover {
    background: #252831;
    border-left: 4px solid green;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }

`;
  
const SidebarLabel = styled.span`
  padding-left: 16px;
  width: max-content !important;
  font-size: 1.8rem;
`;
  
const SidebarDropdown = styled.div`
  font-size: 1.4rem;
  padding-left: 1.6rem;
  width: max-content !important;
`

const DropdownLink = styled(Link)`
  height: 60px;
  padding-left: 3rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #f5f5f5;
  font-size: 18px;
  width: 100% !important;
  
  &:hover {
    background: green;
    cursor: pointer;
  }
`;


export {SubMenu}